import { ReactNode, HTMLProps, PropsWithChildren } from "react";
import { makeStyles, createStyles, Theme, Box } from "@material-ui/core";
import clsx from "clsx";

export type ColumnProps = PropsWithChildren<{
  title: string | ReactNode;
  renderRight?: () => ReactNode;
}> &
  Omit<HTMLProps<HTMLDivElement>, "title">;

export const Column = ({ title, renderRight, children, ...props }: ColumnProps) => {
  const classes = useStyles();
  return (
    <div className={classes.column} {...props}>
      {renderRight ? (
        <div className={clsx(classes.rowTitle, classes.rowBetween)}>
          {title}
          <Box display="flex" alignItems="center">
            {renderRight()}
          </Box>
        </div>
      ) : (
        <div className={classes.rowTitle}>{title}</div>
      )}
      <div className={classes.rowContent}>{children}</div>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    column: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#fbfbfb",
      marginBottom: theme.spacing(2),
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      fontFamily: theme.typography.fontFamily,
    },
    rowBetween: {
      display: "flex",
      justifyContent: "space-between",
    },
    rowTitle: {
      boxShadow: "0 2px 0 white",
      fontSize: 16,
      lineHeight: 1,
      fontWeight: 600,
      color: theme.palette.dark.main,
      paddingLeft: theme.spacing(2.5),
      padding: theme.spacing(2),

      position: "relative",

      "&:after": {
        display: "block",
        content: "''",
        position: "absolute",
        bottom: 0,
        right: 0,
        width: "20%",
        height: 2,
        boxShadow: "0 2px 0 #fbfbfb",
      },
    },
    rowContent: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      paddingTop: 0,
      paddingRight: theme.spacing(2.5),
      paddingLeft: theme.spacing(2.5),
      paddingBottom: theme.spacing(3),
    },
  }),
);
